import Highcharts from 'highcharts';
import AccessibilityModule from 'highcharts/modules/accessibility';

// Highcharts mutates its shared namespace when a module is initialized. Guard
// the call because React's development runtime and tests can evaluate modules
// more than once.
const configuredHighcharts = Highcharts as typeof Highcharts & {
  __ventrisAccessibilityConfigured?: boolean;
};

if (!configuredHighcharts.__ventrisAccessibilityConfigured) {
  AccessibilityModule(Highcharts);
  configuredHighcharts.__ventrisAccessibilityConfigured = true;
}

export default Highcharts;
